import classNames from 'classnames';
import React__default from 'react';
import { ToggleButtonGroup } from 'react-aria-components';
import './ToggleCardGroup.scss';

const ToggleCardGroup = (props) => {
    return (React__default.createElement(ToggleButtonGroup, { orientation: 'vertical', disallowEmptySelection: true, ...props, className: classNames('toggle-card-group--rev', props.className) }, props.children));
};

export { ToggleCardGroup };
//# sourceMappingURL=ToggleCardGroup.js.map
